import type React from "react";

export function ActivityDot(): React.ReactNode {
  return <span data-testid="activity-dot" className="block size-status-dot rounded-full bg-background-danger" />;
}
